
import { useEffect, useState } from "react";
import { Grid, TextField } from "@mui/material"
import { useUnidadesMedidaStore } from "../../../stores";
import { BotonesAndCargando } from "../../components/botones";
import { crearOrEditarUnidadMedida } from "../../../services";
import { useQueryClient } from "@tanstack/react-query";






export const FormularioUnidadMedida = ({ cerrarModal }) => {

    
    const queryClient = useQueryClient();
    const { activarUnidadMedida } = useUnidadesMedidaStore();

    const [cargando, setCargando] = useState(false)
    const [formNombre, setFormNombre] = useState({ nombre: '' });
    const { nombre } = formNombre;
    const handleInputChange = ({ target }) => {
        setFormNombre({
            ...formNombre,
            [target.name]: target.value
        })
    }


    useEffect(() => {
        if( activarUnidadMedida ) {
            setFormNombre( items => ({
                ...items,
                nombre: activarUnidadMedida.nombre
            }))
        }
    }, [activarUnidadMedida])
    


    
    const handleCrearMedida = async(e) => {
        e.preventDefault();

        if( nombre.trim().length < 1 ){ return }
        
        setCargando(true);
        const resp = await crearOrEditarUnidadMedida({...formNombre, id:activarUnidadMedida?.id });
        setCargando(false);
        if(resp) { 
            queryClient.invalidateQueries({ queryKey: ['unidadesMedida-todos'] });
            cerrarModal();
        }
    }



    return (

        <form onSubmit={ handleCrearMedida } >
            <Grid container spacing={ 2 }>

                <Grid item xs={12} sm={12}>
                    <TextField required
                        label='Nombre'
                        type='text'
                        placeholder='Nombre'
                        fullWidth
                        name='nombre'
                        value={ nombre }
                        onChange={ handleInputChange }
                    />
                </Grid>
            </Grid>

            <Grid container sx={{mb:2, mt:3, display:'flex', justifyContent:'center' }}>
                <Grid item xs={12} sm={6} md={5}>
                    <BotonesAndCargando
                        cargando={cargando}
                        titulo={`${(activarUnidadMedida) ? 'Editar' : 'Crear'} Unidad Medida`}
                        titulo2="Loading..."
                        icon1="save"
                        icon2="save"
                        esSubmit
                    />
                </Grid>
            </Grid>

        </form>

    )
}
